export default "__VITE_PUBLIC_ASSET__8fe41731__"